import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { VideoTimestampMarker } from "./VideoTimestampMarker";
export const VideoTimestamp = (param)=>{
    let { activeDiscussionId, duration, markers, onMarkerClick } = param;
    /**
   * @TODO - change `markers` data type earlier on in `getTimestampMarkers` to avoid double
   *  loops through `markers`
   */ const getSharedTimestampMarkers = useCallback((timestamp)=>{
        const sharedMarkers = markers === null || markers === void 0 ? void 0 : markers.filter((marker)=>marker.timestamp === timestamp);
        const activeMarker = sharedMarkers === null || sharedMarkers === void 0 ? void 0 : sharedMarkers.find((marker)=>activeDiscussionId === marker.discussionId);
        const markerToShow = activeMarker || sharedMarkers && sharedMarkers[0];
        const count = sharedMarkers === null || sharedMarkers === void 0 ? void 0 : sharedMarkers.length;
        var _sharedMarkers_map;
        return {
            markerToShow,
            count,
            discussionIds: (_sharedMarkers_map = sharedMarkers === null || sharedMarkers === void 0 ? void 0 : sharedMarkers.map((param)=>{
                let { discussionId } = param;
                return discussionId;
            })) !== null && _sharedMarkers_map !== void 0 ? _sharedMarkers_map : []
        };
    }, [
        activeDiscussionId,
        markers
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none absolute inset-0 z-10",
        children: markers === null || markers === void 0 ? void 0 : markers.map((marker)=>{
            const { markerToShow, count } = getSharedTimestampMarkers(marker.timestamp);
            return /*#__PURE__*/ _jsx(VideoTimestampMarker, {
                onClick: ()=>onMarkerClick(marker.timestamp),
                style: {
                    left: "".concat(marker.timestamp / duration * 100, "%")
                },
                userAvatar: markerToShow === null || markerToShow === void 0 ? void 0 : markerToShow.userAvatar,
                userId: markerToShow ? markerToShow.userId : marker.userId,
                userInitials: count && count > 1 ? "+".concat(count) : (markerToShow === null || markerToShow === void 0 ? void 0 : markerToShow.initials) || ""
            }, marker.discussionId);
        })
    });
};
